import React, { useState } from 'react';
import MobileTopBar from './MobileTopBar';
import MobileBottomNav from './MobileBottomNav';
import MobileMenuSheet from './MobileMenuSheet';

export default function MobileShell({ children }) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="mobile-shell">
      <MobileTopBar />
      <main className="mobile-shell__content">{children}</main>
      <MobileBottomNav onOpenMenu={() => setMenuOpen(true)} />
      <MobileMenuSheet open={menuOpen} onClose={() => setMenuOpen(false)} />
    </div>
  );
}
